import slugify from 'react-slugify'

export const FETCH_SEARCH = 'FETCH_RESULT_SEARCH'
export const FETCH_SEARCH_SUCCESS = `${FETCH_SEARCH}_SUCCESS`

const defaultSort = 'SCORE'

const initialState = {
  services: [],
  products: [],
  hasMoreItems: true,
  hasProducts: false,
  isLoading: true,
  filterChanged: '',
  filterSelected: {
    term: '',
    identifier: '',
    type: 0,
    brand: [],
    category: [],
    subcategory: [],
    vendor: [],
    vendortype: [],
    feature: [],
    minprice: 0,
    maxprice: 0,
    sort: defaultSort
  },
  facetHistory: [],
  validShowcasePage: false,
  showcase: {}
}

export default (state = initialState, action) => {
  const setHistory = dataResult => {
    let facetHistoryCheck = state.facetHistory.filter(
      x =>
        JSON.stringify(x.filterSelected) ===
        JSON.stringify(state.filterSelected)
    )
    if (facetHistoryCheck.length <= 0) {
      state.facetHistory.push({
        filterSelected: {
          term: state.filterSelected.term,
          identifier: state.filterSelected.identifier,
          type: state.filterSelected.type,
          brand: [...state.filterSelected.brand],
          category: [...state.filterSelected.category],
          subcategory: [...state.filterSelected.subcategory],
          vendor: [...state.filterSelected.vendor],
          vendortype: [...state.filterSelected.vendortype],
          feature: [...state.filterSelected.feature],
          minprice: state.filterSelected.minprice,
          maxprice: state.filterSelected.maxprice
        },
        facets: {
          categories: dataResult.categories,
          subcategories: dataResult.subcategories,
          brands: dataResult.brands,
          vendors: dataResult.vendors,
          features: dataResult.features
        }
      })
    }
  }

  const getDataResultHistory = (filterSingle, filterPlural, dataResult) => {
    const filterSelectedState = { ...state.filterSelected }
    filterSelectedState[filterSingle] = []
    let facetHistoryCheck = state.facetHistory.filter(
      f =>
        JSON.stringify(f.filterSelected) === JSON.stringify(filterSelectedState)
    )
    let facetsHistory =
      facetHistoryCheck.length > 0
        ? facetHistoryCheck[0].facets[filterPlural]
        : dataResult[filterPlural]

    state.filterSelected[filterSingle] = facetsHistory
      .filter(f =>
        state.filterSelected[filterSingle].some(s => s === String(f.id))
      )
      .map(m => {
        return String(m.id)
      })

    return facetsHistory
  }

  switch (action.type) {
    case 'SET_FILTER_CHANGED':
      return {
        ...state,
        filterChanged: action.payload.filterName,
        filterSelected: action.payload.filterSelected
      }
    case 'FETCH_RESULT_SEARCH':
      return { ...state, isLoading: true }
    case 'FETCH_RESULT_SEARCH_SUCCESS':
      const dataResult = action.payload.data

      setHistory(dataResult)

      let uniquesProducts = [...state.products, ...dataResult.products].filter((item, index, self) =>
        index === self.findIndex((t) => (
          t.sku === item.sku
        ))
      )

      return {
        ...state,
        hasMoreItems:
        uniquesProducts.length <
          dataResult.totalRowCount && dataResult.products.length > 0,
        services: [...state.services, ...dataResult.services || []],
        products: [...state.products, ...dataResult.products || []],
        quantityFoundProducts: dataResult.totalRowCount,
        categories: dataResult.categories,
        subcategories: dataResult.subcategories,
        brands: getDataResultHistory('brand', 'brands', dataResult),
        vendors: getDataResultHistory('vendor', 'vendors', dataResult),
        features: dataResult.features,
        facetHistory: state.facetHistory,
        filterSelected: state.filterSelected,
        isLoading: false,
        lowerPrice: dataResult.lowerPrice,
        higherPrice: dataResult.higherPrice,
        showcase: dataResult.showcase
      }
    case 'FETCH_RESULT_SEARCH_FAIL':
      return { ...state, error: action.error, isLoading: false }
    case 'CLEAR_PRODUCTS':
      return {
        ...state,
        services: [],
        products: [],
        isLoading: false
      }
    case 'FETCH_SEARCH_CARD_AVAILABILITY':
      return { ...state }
    case 'FETCH_SEARCH_CARD_AVAILABILITY_SUCCESS':
      const availability = action.payload.data[0]
      const { products } = state
      const {
        meta: {
          previousAction: { sku }
        }
      } = action
      const index = products.findIndex(p => p.sku === sku)

      if (products[index]) {
        products[index].availability = {
          ...availability
        }
      }

      return { ...state, products }
    case 'FETCH_SEARCH_CARD_AVAILABILITY_FAIL':
      return { ...state, error_availability: action.error }
    case 'SEARCH_PAGE_RESET_STATE':
      return { ...initialState }
    default:
      return { ...state }
  }
}
const restrictProducts = process.env.REACT_APP_RESTRICT_PRODUCTS ? process.env.REACT_APP_RESTRICT_PRODUCTS.split(',') : []
const checker = (value) => {
  for (var i = 0; i < restrictProducts.length; i++) {
    if (value.indexOf(restrictProducts[i]) > -1) {
      return false
    }
  }
  return true
}

export const SearchFiltered = (searchResult, router) => {
  searchResult.products.map(prod => {
    var vendor = searchResult.vendors.filter(v => v.id === prod.vendor.id)
    prod.vendor.imageUrl = vendor.length > 0 ? vendor[0].imageUrl : ''
  })

  let removeCategories = process.env.REACT_APP_REMOVE_CATEGORIES ? process.env.REACT_APP_REMOVE_CATEGORIES.split(',') : []
  let removeSubcategories = process.env.REACT_APP_REMOVE_SUBCATEGORIES ? process.env.REACT_APP_REMOVE_SUBCATEGORIES.split(',') : []

  if (restrictProducts.length) {
    searchResult.products = searchResult.products.filter(el => checker(el.name.toLowerCase()))
  }

  var filteredCategories = []
  var filteredSubcategories = []

  if (searchResult.categories && searchResult.categories.length) {
    searchResult.categories.map((cat) => {
      if (!removeCategories.includes(slugify(cat.name, { delimiter: '-' }))) {
        filteredCategories.push(cat)
      }
    })
  }

  if (searchResult.subcategories && searchResult.subcategories.length) {
    searchResult.subcategories.map((sub) => {
      if (!removeSubcategories.includes(slugify(sub.name, { delimiter: '-' }))) {
        filteredSubcategories.push(sub)
      }
    })
  }

  let products = searchResult.products.filter((item, index, self) =>
    index === self.findIndex((t) => (
      t.sku === item.sku
    ))
  )
  return {
    services: searchResult.services,
    products: products,
    hasMoreItems: searchResult.hasMoreItems,
    hasNoProducts: searchResult.services.length <= 0 && searchResult.products.length <= 0,
    quantityFoundProducts: searchResult.quantityFoundProducts,
    categories: filteredCategories,
    subcategories: filteredSubcategories,
    brands: searchResult.brands,
    vendors: searchResult.vendors,
    features: searchResult.features,
    filtersName: router.location.search,
    isLoading: searchResult.isLoading,
    priceLimit: {
      min: searchResult.lowerPrice,
      max: searchResult.higherPrice
    },
    filterSelected: searchResult.filterSelected,
    facetHistory: searchResult.facetHistory,
    validShowcasePage:
      searchResult.filterSelected.identifier &&
      searchResult.filterSelected.type > 0,
    showcase: searchResult.showcase
  }
}

export const fetchResultSearch = typeSearch => (
  term,
  identifier,
  type,
  brands,
  categories,
  subcategories,
  vendors,
  vendortype,
  features,
  minprice,
  maxprice,
  sort,
  pageIndex
) => ({
  type: 'FETCH_RESULT_SEARCH',
  payload: {
    client: 'cloudloyalty',
    request: {
      url:
        (typeSearch === 'showcase'
          ? `/v2/showcases/${identifier}/${type}/?cachedPrice=true`
          : `/v2/products/?cachedPrice=true${setFilter(
            term,
            'term'
          )}`) +
        `${setFilter(brands, 'brands')}` +
        `${setFilter(categories, 'categories')}` +
        `${setFilter(subcategories, 'subcategories')}` +
        `${setFilter(vendors, 'vendors')}` +
        `${setFilter(vendortype, 'vendortypes')}` +
        `${setFilter(features, 'features')}` +
        `${setFilter(minprice, 'minprice')}` +
        `${setFilter(maxprice, 'maxprice')}` +
        `${setFilter(sort, 'sort', `&sort=${defaultSort}`)}` +
        `&pageIndex=${pageIndex}&pageSize=12`
    }
  }
})

const setFilter = (filters, paramName, defaultFilter = '') => {
  let featureIndex = 0
  if (Array.isArray(filters)) {
    let queryFilter = ''
    filters.map(filter => {
      queryFilter += filter
        ? defineFilterValue(filter, paramName, featureIndex++)
        : defaultFilter
    })
    return queryFilter
  }
  return filters
    ? defineFilterValue(filters, paramName, featureIndex++)
    : defaultFilter
}

const defineFilterValue = (filter, paramName, featureIndex) => {
  switch (paramName) {
    case 'features':
      let filterSplitted = filter.split('_')
      return (
        '&Features[' +
        featureIndex +
        '].Type=' +
        filterSplitted[0] +
        '&Features[' +
        featureIndex +
        '].Value=' +
        filterSplitted[1]
      )
    default:
      return '&' + paramName + '=' + filter
  }
}

export const clearSearch = () => ({
  type: 'CLEAR_PRODUCTS'
})

export const setFilterChanged = (filterName, filterSelected) => ({
  type: 'SET_FILTER_CHANGED',
  payload: {
    filterName: filterName,
    filterSelected: filterSelected
  }
})

export const resetState = () => ({
  type: 'SEARCH_PAGE_RESET_STATE'
})



// WEBPACK FOOTER //
// ./src/Catalog/Search/ducks.js